import React from 'react';
import { FaEnvelope, FaPhone, FaMapMarkerAlt, FaGithub, FaLinkedin, FaTwitter } from 'react-icons/fa';
import logoImage from '../images/logo.png';
import { useLanguage } from '../contexts/LanguageContext';
import './Footer.css';

const Footer = () => {
  const { t } = useLanguage();
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section">
          <div className="footer-logo">
            <img src={logoImage} alt="CodeArtisan" className="footer-logo-img" />
          </div>
          <p className="footer-description">
            Plataforma AutoNav - Soluções profissionais de rastreamento GPS 
            com tecnologia de ponta e suporte especializado.
          </p>
          <div className="social-links">
            <a href="#" className="social-link"><FaGithub /></a>
            <a href="#" className="social-link"><FaLinkedin /></a>
            <a href="#" className="social-link"><FaTwitter /></a>
          </div>
        </div>

        <div className="footer-section">
          <h4>Links Rápidos</h4>
          <ul className="footer-links">
            <li><a href="#hero">Início</a></li>
            <li><a href="#devices">Dispositivos</a></li>
            <li><a href="#contact">Contato</a></li>
            <li><a href="https://www.traccar.org/devices/" target="_blank" rel="noopener noreferrer">Documentação Traccar</a></li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Contato</h4>
          <ul className="footer-contact">
            <li>
              <FaEnvelope />
              <span>suporte@autonav.com.br</span>
            </li>
            <li>
              <FaPhone />
              <span>+55 75 9804-7076</span>
            </li>
            <li>
              <FaMapMarkerAlt />
              <span>Feira de Santana , BA - Brasil</span>
            </li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Tecnologia</h4>
          <p className="footer-tech">
            Desenvolvido com React.js e integrado com protocolos Traccar para 
            máxima compatibilidade e performance.
          </p>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; 2025 AutoNav. Todos os direitos reservados.</p>
        <p className="footer-credits">
          Protocolos baseados em <a href="https://www.traccar.org" target="_blank" rel="noopener noreferrer">Traccar</a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;

